import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { AccountsService } from "./accounts.service";
import { UsersService } from "../users/users.service";
import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ProjectsService } from "../projects/projects.service";

@Component({
  selector: "account-detail",
  template: require('./accountdetail.component.html'),
  styles: [require('./accountdetail.component.scss')]
})
export class AccountDetailComponent implements OnInit {
  account: any = undefined;
  //clear the old user data before creating new user
  newuser: any; // save new user info
  activePanels: string[] = ["details", "users", "projects"];
  employers: any[] = [];
  projects: any[] = [];
  projectId: string = null;
  users: any[] = [];
  sent: boolean = false;
  errorMessage: any = null;
  projectIds: any[] = []; //array of project Id's
  projectNames: any[] = []; //array of objects with project id and names
  selectedProjectId: string; //Id of the project that is clicked on
  @ViewChild("modalTemplate") private modalComponent: TemplateRef<any>;
  @ViewChild("addProjectModalTemplate")
  private addProjectModalComponent: TemplateRef<any>;
  @ViewChild("addUserModalTemplate") private addUserModalComponent: TemplateRef<
    any
  >;
  dialog: NgbModalRef;

  constructor(
    private service: AccountsService,
    private usersService: UsersService,
    private router: Router,
    private modalService: NgbModal,
    private projectService: ProjectsService
  ) {}

  ngOnInit() {
    this.account = AccountsService.currentAccount;
    if (this.account) {
      if (this.account.project_ids && this.account.project_ids.length) {
        this.account.project_ids.forEach((proj) => {
          this.projectService.getProject(proj).subscribe((project) => {
            this.projectNames = [...this.projectNames, project];
          });
        });
      }
      this.service.getEmployers().subscribe((employers) => {
        this.employers = employers;
      });
      if (!this.account.users) {
        this.usersService.getUsers(this.account.id).subscribe((users) => {
          this.users = users;
          this.getProjectMembers();
        });
      } else {
        this.users = this.account.users;
        delete this.account.users;
        this.getProjectMembers();
      }
    } else {
      this.router.navigate(["/accounts"]);
    }
  }

  //get user details
  showUserDetails(user: any) {
    UsersService.currentUser = user;
    this.router.navigate(["/userdetail"]);
  }

  getProjectName(id: string): string {
    if (!this.projects) {
      return;
    }
    return this.projects.filter((item) => {
      return item.id === id;
    })[0].name;
  }

  showModal() {
    if (!this.sent) {
      this.dialog = this.modalService.open(this.modalComponent);
    }
  }

  showDeleteProjModal(project) {
    this.selectedProjectId = project;
    this.showModal();
  }

  //Removes the project from the Backend with API call.
  removeProject(result) {
    this.dialog.close();
    if (result) {
      this.account = {
        ...this.account,
        project_ids: this.account.project_ids.filter(
          (proj) => proj !== this.selectedProjectId
        )
      };

      this.projectNames = this.projectNames.filter(
        (proj) => proj.id !== this.selectedProjectId
      );

      this.service
        .editAccount(this.account, this.users)
        .subscribe((account) => {});
    }
  }

  showAddProjectModal() {
    if (!this.sent) {
      this.dialog = this.modalService.open(this.addProjectModalComponent);
    }
  }

  addProject(result, prIdToBeAdded) {
    this.dialog.close();
    if (result) {
      // if user clicked save, then add the project by calling the add method on service and on getting the result, call the addProjectToList()
      this.account = {
        ...this.account,
        project_ids: [...this.account.project_ids, prIdToBeAdded]
      };

      this.projectService.getProject(prIdToBeAdded).subscribe((proj) => {
        this.projectNames = [...this.projectNames, proj];
      });

      this.service
        .editAccount(this.account, this.users)
        .subscribe((account) => {});
    }
  }

  addProjectToList(projectId: string) {
    let arr = this.account.project_ids;
    let index = arr.indexOf(projectId);
    if (index == -1) {
      //add the projectId to the array
      arr.push(projectId);
      this.projectNames = this.service.getProjNames(arr);
    }
  }

  //display the add user modal
  showAddUserModal() {
    this.newuser = {}; //initialize an empty object for each new user.
    if (!this.sent) {
      this.dialog = this.modalService.open(this.addUserModalComponent);
    }
  }

  //call this method when user performs an action inside the modal (click 'Save' or 'Cancel')
  addUserModalFormSubmit(result) {
    this.dialog.close();
    if (result) {
      //If user clicked Yes, then add the user by calling addUserToList()
      this.addUserToList(this.newuser);
    }
  }

  //add to the list of users displayed
  addUserToList(newUser) {
    const nUser = {
      active: newUser.status ? newUser.status : false,
      name: newUser.name,
      email: newUser.email
    };

    this.usersService.createUser(nUser, this.account.id).subscribe((dat) => {
      const users = [
        ...this.users.map((raw) => {
          delete raw.newPassword;
          delete raw.oldPassword;
          delete raw.status;

          return raw;
        }),
        dat
      ];
      this.service.editAccount(this.account, users).subscribe((data) => {
        this.users.push(dat);
      });
    });
  }

  getProjectMembers() {
    this.service.getProjects().subscribe((projects) => {
      this.projects = projects;
      this.service
        .getProjectMemberList(this.account.project_ids)
        .subscribe((members) => {
          this.users.map((user) => {
            members.map((member) => {
              if (member.user_id === user.id) {
                if (!user.projects) {
                  user.projects = [];
                }
                let project = this.projects.filter((it) => {
                  return it.id === member.project_id;
                })[0];
                user.projects.push({
                  name: project.name,
                  id: project.id,
                  role: member.role
                });
              }
            });
          });
        });
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/accountdetail.component.ts